import { IconButton, Tooltip } from "@mui/material"
import { useSnackbar } from "notistack"
import Iconify from "minimals-template/components/Iconify"
import { confirm } from "lib/@dialogs/confirm"
import { removeCommentarySection } from "../controller/remove-commentary-section"

export function ScheduleCommentaryRemoveSectionButton({ section }) {
    const { enqueueSnackbar } = useSnackbar()

    return (
        <Tooltip title="Remove section">
            <IconButton
                size="small"
                color="error"
                onClick={handleRemove}
                aria-label={`Remove section ${section.title}`}
                data-cy="schedule-commentary-remove-section"
            >
                <Iconify icon="mdi:delete-outline" />
            </IconButton>
        </Tooltip>
    )

    async function handleRemove() {
        const message = section.schedules?.length
            ? `Remove "${section.title}"? Its commentaries will go back to the sections they started in.`
            : `Remove "${section.title}"?`
        if (!(await confirm(message, "Remove section", undefined, "Remove", { okColor: "error" }))) return
        try {
            await removeCommentarySection({ id: section.id })
            enqueueSnackbar(`Removed "${section.title}"`, { variant: "success" })
        } catch (error) {
            enqueueSnackbar(error.message || "Failed to remove section", { variant: "error" })
        }
    }
}
